<template>
  <div>
    <p class="py-2 text-xs text-gray-500 text-right">
      Send as <span class="text-gray-600">{{ displayName }}</span
      >.
      <TextButton size="xs" underlined @click="changeDisplayName()">
        Change
      </TextButton>
    </p>
    <Modal
      v-model="isModalOpen"
      title="Update display name"
      wide
      @close="onModalClose"
    >
      <p class="text-gray-500 text-sm">
        Here you can change your display name - how others see you in
        conversations.
      </p>
      <p v-if="!user.display_name" class="text-gray-500 text-sm">
        Please note that this is reuquired to use our conversations platform.
      </p>
      <ChangeDisplayNameForm
        :initial-data="{ display_name: user.display_name }"
        @close="closeModal"
      />

      <p
        v-if="triedToCloseBeforeSettingDisplayName && !displayNameIsAlreadySet"
        class="text-red-500 text-sm pt-6"
      >
        You must provide display name before using vestbee conversation
        platform.
        <TextButton underlined @click="cancel()">
          Get me back.
        </TextButton>
      </p>
    </Modal>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import TextButton from 'components/common/TextButton'
import Modal from 'components/common/Modal'
import useUser from 'states/useUser'
import ChangeDisplayNameForm from './ChangeDisplayNameForm'

export default {
  name: 'DisplayNameInfo',
  components: { Modal, TextButton, ChangeDisplayNameForm },
  setup(props, { emit }) {
    const { user, goToDefaultUserPage } = useUser()
    const displayName = computed(() => user.value.display_name || '-')

    const initialIsOpen = !user.value.display_name

    const isModalOpen = ref(false)
    Vue.nextTick(() => {
      isModalOpen.value = initialIsOpen
    })

    const changeDisplayName = () => {
      isModalOpen.value = true
    }
    const onModalClose = () => {
      emit('on-modal-close')
    }
    const closeModal = () => {
      isModalOpen.value = false
    }

    const displayNameIsAlreadySet = computed(() => {
      if (user.value.display_name) {
        return user.value.display_name.length > 1
      }
      return false
    })

    const triedToCloseBeforeSettingDisplayName = ref(false)

    const cancel = () => {
      goToDefaultUserPage()
    }

    return {
      user,
      displayName,
      changeDisplayName,
      onModalClose,

      isModalOpen,
      displayNameIsAlreadySet,
      triedToCloseBeforeSettingDisplayName,
      closeModal,

      cancel,
    }
  },
}
</script>
